class Modal extends HTMLElement {
  static get observedAttributes() {
    return ['is-visible'];
  }

  constructor() {
    super();

    this.buttonType = this.dataset.buttonType || false;
    this.modalName = this.dataset.modalName || false;
  }

  get isVisible() {
    return this.hasAttribute('is-visible');
  }

  set isVisible(value) {
    this[value ? 'setAttribute' : 'removeAttribute']('is-visible', '')
  }

  connectedCallback() {
    this._render();
    this._attachEventHandlers();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'is-visible' && this.shadowRoot) {
      newValue === null ? this.close() : this.open();
    }
  }

  show() {
    this.open()
  }

  open() {
    this.shadowRoot.querySelector('.wrapper').classList.add('is-visible');
    document.documentElement.classList.add('scroll-lock')
    document.body.classList.add('scroll-lock')
    this.classList.remove('visibility-hidden');
    this.classList.remove('hidden');
    trapFocus(this, null, this.shadowRoot);
  }

  close() {
    this.shadowRoot.querySelector('.wrapper').classList.remove('is-visible');
    document.documentElement.classList.remove('scroll-lock')
    document.body.classList.remove('scroll-lock')
    this.classList.add('visibility-hidden');
    removeTrapFocus();
  }

  _render() {
    const wrapperClass = this.isVisible ? 'wrapper is-visible' : 'wrapper';
    const shadowRoot = this.attachShadow({mode: 'open'});
    shadowRoot.innerHTML = `
      <style>
        .wrapper {
          position: fixed;
          left: 0;
          top: 0;
          width: 100%;
          height: var(--modal-wrapper-height, 100%);
          opacity: 0;
          visibility: hidden;
          transform: scale(1.1);
          transition: visibility 0s linear .25s,opacity .25s 0s,transform .25s;
          z-index: 1000;
        }
        .is-visible {
          opacity: 1;
          visibility: visible;
          transform: scale(1);
          transition: visibility 0s linear 0s,opacity .25s 0s,transform .25s;
        }
        .modal {
          padding: var(--modal-padding, 30px 20px);
          background-color: var(--modal-background-color, #ffffff);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          border: 1px solid var(--modal-border-color, none);
          border-radius: var(--modal-border-radius, 5px);
          min-width: var(--modal-min-width, 300px);
          max-width: 428px;
          box-shadow: 5px 10px 30px rgba(28, 28, 28, 0.1);
        }
        header {
          display: flex;
          padding: var(--modal-header-padding, 0 0 10px 0);
          border-bottom: 1px solid var(--modal-header-border-color, var(--color-primary));
        }
        .icon.close {
          display: block;
          height: 17px;
          width: 17px;
          cursor: pointer;
          margin: auto;
          margin-right: 0;
        }
        .content {
          padding: var(--modal-content-padding, 30px 0);
        }
        ::slotted([slot="footer"]) {
          width: calc(100% - 20px);
        }
      </style>

      <div class='${wrapperClass}'>
        <aside class='modal' role="dialog">
          <header>
            <slot name="title"></slot>
            <span class="icon close" aria-label="Close" tabindex="0">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close icon-remove" fill="none" viewBox="0 0 18 17">
                <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
              </svg>
            </span>
          </header>
          <div class='content'>
            <slot name="body"></slot>
          </div>
          <footer>
            <slot name="footer"></slot>
          </footer>
        </aside>
      </div>`;
  }

  _attachEventHandlers() {
    ['click', 'keydown'].forEach(evt => {
      this.shadowRoot.querySelector(['.close']).addEventListener(evt, e => {
        if (e.code?.toLowerCase() === 'enter' || evt === 'click') this.close()
      })
    })

    document.addEventListener('open-modal', e => {
      if (this.modalName === e.detail.modal_name) this.open()
    })

    document.addEventListener('close-modal', e => {
      if (this.modalName === e.detail.modal_name) this.close()
    })

    this.shadowRoot.querySelector('.wrapper').addEventListener('click', e => {
      if (e.target == e.currentTarget) this.close()
    })

    const buttons = this.querySelectorAll('button')
    buttons.forEach(button => {
      button.addEventListener('click', e => {
        this.buttonType
          ? this.dispatchEvent(new CustomEvent('handle-action', { detail: this.buttonType }))
          : this.close()
      })
    })
  }
}
window.customElements.define('hh-modal', Modal);
